import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import Tabela from "../../components/Tabela";
import { getPerguntaById } from "../../api/checkilstApi";
import { toast } from "react-toastify";
import { Pergunta, Resposta } from "../../types/checklistData";

const Respostas: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [respostas, setRespostas] = useState<Resposta[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPergunta = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const perguntaData: Pergunta = await getPerguntaById(token, id!);
        setRespostas(perguntaData.respostas);
      } catch (error) {
        toast.error("Erro ao buscar Pergunta!");
        console.error("Erro ao buscar Pergunta:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPergunta();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleEditResposta = (id: string) => {
    navigate(`/editarResposta/${id}`);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_checklist_resposta", label: "Descrição da Resposta" },
    { id: "valor_checklist_respostas", label: "Valor" },
  ];

  const dadosConvertidos = respostas.map((resposta) => ({
    ...resposta,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Respostas"
        colunas={colunas}
        dados={dadosConvertidos}
        loading={loading}
        showBackButton={true}
        onEdit={handleEditResposta}
        onBack={handleBack}
      />
    </Box>
  );
};

export default Respostas;
